export const isCasperWalletMobileIOS = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false;
  }
  const ua = window.navigator.userAgent;
  return ua.includes('CasperWalletMobile') && !/Android/i.test(ua);
};
